import { Component } from '@angular/core';

@Component({
  selector: 'app-error-contact-customer-support',
  templateUrl: './error-contact-customer-support.component.html',
  styleUrls: ['./error-contact-customer-support.component.scss'],
  standalone: true,
})
export class ErrorContactCustomerSupportComponent {}
